export default function getLotterySub(lottery, user) {
    let token = localStorage.getItem("token");
    let urls = [
        `/wp-json/achim/v1/lottery/${lottery}/user/${user}?lottery=${lottery}&user=${user}`,
        `/wp-json/achim/v1/hours/${user}/summary`
    ]
    let options = {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Authorization': 'Bearer ' + token
        }
    };
    return Promise.all(urls.map(u => fetch(u, options))).then(responses =>
        Promise.all(responses.map(res => res.json()))
    ).then(res => {
        return res;
    })
}